import { CommentFormItem } from '../CommentFormItem'
import CIMSSelect from 'components/CIMSSelect'
import CIMSFormItem from 'components/CIMSFormItem'

export const GroupReviewerActions: React.VFC = () => {
  return (
    <>
      <CIMSFormItem
        name="action"
        label="Action"
        requiredMessage="Please select an Action"
      >
        <CIMSSelect
          simple
          options={[
            {
              label: 'Route to Resident Engineer Review',
              value: 'groupReview',
            },
            {
              label: 'Request Revisions',
              value: 'requestRevisions',
            },
          ]}
        />
      </CIMSFormItem>
      <CommentFormItem required={{ action: 'review' }} />
    </>
  )
}
